import { render } from "./POS.vue?vue&type=template&id=bf8d4626&scoped=true"
import script from "./POS.vue?vue&type=script&lang=js"
export * from "./POS.vue?vue&type=script&lang=js"

import "./POS.vue?vue&type=style&index=0&id=bf8d4626&scoped=true&lang=css"
import "./POS.vue?vue&type=style&index=1&id=bf8d4626&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf8d4626"]])

export default __exports__